var _rect, _rect2, _rect3, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features",
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 800,
    transform: "translate(-512 -304)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 3043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -728,
    y: -278,
    width: 863,
    height: 744
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    x: 135,
    y: -278,
    width: 744,
    height: 863,
    transform: "rotate(90 135 -278)",
    fill: "url(#paint0_radial_0_1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cell"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 27,
    cy: 10,
    r: 1.5,
    transform: "rotate(90 27 10)",
    fill: "#CAC8D4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cell_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1_2",
    cx: 27,
    cy: 34,
    r: 1.5,
    transform: "rotate(90 27 34)",
    fill: "#CAC8D4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cell_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1_3",
    cx: 3,
    cy: 10,
    r: 1.5,
    transform: "rotate(90 3 10)",
    fill: "#CAC8D4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cell_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1_4",
    cx: 3,
    cy: 34,
    r: 1.5,
    transform: "rotate(90 3 34)",
    fill: "#CAC8D4"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Container_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38 10.0742H10C7.79086 10.0742 6 11.8651 6 14.0742V38.0742C6 40.2834 7.79086 42.0742 10 42.0742H38C40.2091 42.0742 42 40.2834 42 38.0742V14.0742C42 11.8651 40.2091 10.0742 38 10.0742Z",
    fill: "#9B62FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42 16.0742H6V14.0742C6.00005 13.0134 6.4215 11.996 7.17163 11.2458C7.92177 10.4957 8.93915 10.0743 10 10.0742H38C39.0608 10.0743 40.0782 10.4957 40.8284 11.2458C41.5785 11.996 41.9999 13.0134 42 14.0742V16.0742Z",
    fill: "#C3A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.0371 14C13.7932 14 13.5516 13.952 13.3263 13.8586C13.1009 13.7653 12.8962 13.6285 12.7237 13.456C12.5512 13.2835 12.4144 13.0788 12.3211 12.8534C12.2277 12.628 12.1797 12.3865 12.1797 12.1426V7.85742C12.1797 7.6135 12.2277 7.37197 12.3211 7.14662C12.4144 6.92126 12.5512 6.7165 12.7237 6.54403C12.8962 6.37155 13.101 6.23473 13.3263 6.14139C13.5517 6.04804 13.7932 6 14.0371 6C14.281 6 14.5226 6.04804 14.7479 6.14139C14.9733 6.23473 15.178 6.37155 15.3505 6.54403C15.523 6.7165 15.6598 6.92126 15.7531 7.14662C15.8465 7.37197 15.8945 7.6135 15.8945 7.85742V12.1426C15.8944 12.6352 15.6986 13.1075 15.3503 13.4558C15.002 13.8041 14.5297 13.9998 14.0371 14Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.9629 14C33.719 14 33.4774 13.952 33.2521 13.8586C33.0267 13.7653 32.822 13.6285 32.6495 13.456C32.477 13.2835 32.3402 13.0788 32.2468 12.8534C32.1535 12.628 32.1055 12.3865 32.1055 12.1426V7.85742C32.1055 7.3648 32.3012 6.89236 32.6495 6.54403C32.9978 6.19569 33.4703 6 33.9629 6C34.4555 6 34.9279 6.19569 35.2763 6.54403C35.6246 6.89236 35.8203 7.3648 35.8203 7.85742V12.1426C35.8202 12.6352 35.6244 13.1075 35.2761 13.4558C34.9278 13.8041 34.4555 13.9998 33.9629 14Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.999 20H12.0723C10.9677 20 10.0723 20.8954 10.0723 22V25.9258C10.0723 27.0303 10.9677 27.9258 12.0723 27.9258H15.999C17.1036 27.9258 17.999 27.0303 17.999 25.9258V22C17.999 20.8954 17.1036 20 15.999 20Z",
    fill: "#C3A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.9629 20H22.0371C20.9325 20 20.0371 20.8954 20.0371 22V25.9258C20.0371 27.0303 20.9325 27.9258 22.0371 27.9258H25.9629C27.0675 27.9258 27.9629 27.0303 27.9629 25.9258V22C27.9629 20.8954 27.0675 20 25.9629 20Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.9268 20H32C30.8954 20 30 20.8954 30 22V25.9258C30 27.0303 30.8954 27.9258 32 27.9258H35.9268C37.0313 27.9258 37.9268 27.0303 37.9268 25.9258V22C37.9268 20.8954 37.0313 20 35.9268 20Z",
    fill: "#C3A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.999 30.127H12.0723C10.9677 30.127 10.0723 31.0224 10.0723 32.127V36.0527C10.0723 37.1573 10.9677 38.0527 12.0723 38.0527H15.999C17.1036 38.0527 17.999 37.1573 17.999 36.0527V32.127C17.999 31.0224 17.1036 30.127 15.999 30.127Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.9629 30.127H22.0371C20.9325 30.127 20.0371 31.0224 20.0371 32.127V36.0527C20.0371 37.1573 20.9325 38.0527 22.0371 38.0527H25.9629C27.0675 38.0527 27.9629 37.1573 27.9629 36.0527V32.127C27.9629 31.0224 27.0675 30.127 25.9629 30.127Z",
    fill: "#C3A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M35.9268 30.127H32C30.8954 30.127 30 31.0224 30 32.127V36.0527C30 37.1573 30.8954 38.0527 32 38.0527H35.9268C37.0313 38.0527 37.9268 37.1573 37.9268 36.0527V32.127C37.9268 31.0224 37.0313 30.127 35.9268 30.127Z",
    fill: "#DBC6FF"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(507 585) rotate(-90) scale(802.17 407.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991144,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 800,
    fill: "white",
    transform: "translate(-512 -304)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPurple);
export default __webpack_public_path__ + "static/media/CalendarPurple.33760758c925f692aa03474c680a5f65.svg";
export { ForwardRef as ReactComponent };